export default "__VITE_ASSET__BHZKSfSO__"